import DemoNoticeDialog from "../../components/DemoNoticeDialog/DemoNoticeDialog";
import EmergencyContacts from "../../components/emergency-contacts/EmergencyContacts";
import HeroSection from "../../components/hero/HeroSection";
import LatestUpdates from "../../components/news/LatestUpdates";
import QuickAccess from "../../components/quick-access/QuickAccess";

const HeroPage = () => {
  return (
    <>
      <DemoNoticeDialog />
      <HeroSection />
      <QuickAccess />
      <EmergencyContacts />
      <LatestUpdates />
    </>
  );
};

export default HeroPage;
